import styled from "styled-components";

export const RoadmapTitle = styled.h2`
    
    display: absolute;
    
    font-size: 60px;
    color: white;
    margin-top: 0%;
    font-family: 'Gemunu Libre', sans-serif;
    font-weight: 100;
    margin-bottom: 10px;

    @media screen and (max-width: 768px) {
    margin-top: 10%;
    font-size: 2em;
    }
`

export const Para = styled.p`
    color: white;
    width: 70vw;
    height: fit-content;
    font-size: 22px;
    margin: 0% 0%;
    
    font-family: 'Titillium Web', sans-serif;

    @media screen and (max-width: 1311px) {
    font-size: 22px;
    margin-bottom: 20px;
    }
    
`

export const SubRoad = styled.h5`
    margin: 0 auto;
    color: white;
    font-family: 'Gemunu Libre', monospace;
    font-weight: 100;
    margin-bottom: 5%;
    @media screen and (max-width: 768px) {
    text-align: center;
    }
`
